import "./style.scss";
import "./style-mob.scss";
import whyChooseBg from "@/src/assets/HomePage/WhyChoose/why-choose-bg.png";
import Alert from "@/src/assets/HomePage/WhyChoose/alert.png";
import ReadMoreBtn from "@/src/components/ReadMoreBtn/ReadMoreBtn";
import whyChooseMob from "@/src/assets/HomePage/WhyChoose/why-choose-mob.png";
import { Link } from "react-router-dom";

const WhyChoose = () => {
  return (
    <>
      {window.innerWidth <= 768 ? (
        <Link to={"/"} className="why-choose-mob container">
          <img src={whyChooseMob} alt="Img" />
        </Link>
      ) : (
        <div className="why-choose section-margin-top">
          <div className="why-choose-bg">
            <img src={whyChooseBg} alt="why Choose Bg" />
          </div>
          <div className="why-choose-content">
            <div className="why-choose-title">
              <p>why choose MSMB?</p>
            </div>
            <div className="why-choose-description">
              <p>
                <span>Malta School of medicine & business</span> is a dynamic and innovative university dedicated to providing
                professional degree courses to students from all over the world. Our mission is to unite a diverse and inclusive community
                of learners, researchers, and professionals to develop the world around us.
              </p>
              <p>
                <span>Malta School of medicine & business</span> professors, alumni, and students are passionate about
                exploring new ideas, pushing boundaries, and creating real-world solutions to complex challenges. With a focus on
                collaboration and experiential learning, we offer a wide range of programs to prepare our graduates for successful careers
                in high-demand fields.
              </p>
              <p>
                <span>Malta School of medicine & business</span> offers On-Campus and Online degree courses depending on
                students' interests and comfort. We provide a supportive learning environment to encourage intellectual curiosity, critical
                thinking, and creativity. Our graduates are prepared for successful careers in a variety of industries and sectors. Our
                alumni network spans Europe, Asia, and the USA.
              </p>
            </div>
            <div className="why-choose-alert">
              <img src={Alert} alt="Alert" />
              <p>Your success is our main priority! Join us today to learn from the best.</p>
            </div>
            <div className="why-choose-link">
              <ReadMoreBtn text="Read More →" link="#" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default WhyChoose;
